import { GET_ORDER_REQUEST, GET_ORDER_SUCCESS,CART_PROFILE_UPDATE, GET_ORDER_FAILURE, SAVE_ORDER_FAILURE, SAVE_ORDER_REQUEST, SAVE_ORDER_SUCCESS , GET_STORE_CREDIT_FAILURE, GET_STORE_CREDIT_SUCCESS, GET_STORE_CREDIT_REQUEST, SEGREGATE_CART_REQUEST, SEGREGATE_CART_SUCCESS, SEGREGATE_CART_FAILURE} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    orderInfo: null,
    storeCredit: null,
    storeCreditLoading: true,
    storeCreditError: null,
    success: null,
    successLoading: false,
    ssuccessLoading: true,

    successError: null,
    error: null,
    segregateCartData: null,
    profile_data : null,
};

export default function cartReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ORDER_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                // always replacing data
                orderInfo: action.data.endless_aisle_orders[0],
            };
        case GET_ORDER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case GET_STORE_CREDIT_REQUEST:
            return {
                ...state,
                storeCreditLoading: true,
            };
        case GET_STORE_CREDIT_SUCCESS:
            return {
                ...state,
                // always replacing data
                storeCredit: action.data,
                storeCreditLoading: false,
                error: null

            };
        case GET_STORE_CREDIT_FAILURE:
            return {
                ...state,
                loading: false,
                storeCreditError: action.error,
            };
        case SAVE_ORDER_REQUEST:
            return {
                ...state,
                ssuccessLoading: true,
            };
        case SAVE_ORDER_SUCCESS:
            return {
                ...state,
                ssuccessLoading: false,
                // always replacing data
                success: action.data.status,
                orderInfo: null
            };
        case SAVE_ORDER_FAILURE:
            return {
                ...state,
                ssuccessLoading: false,
                successError: action.error,
            };

        case SEGREGATE_CART_REQUEST:
            return{
                ...state,
                successLoading: true,
            }
        case SEGREGATE_CART_SUCCESS:
            return{
                ...state,
                successLoading: false,
                success: action.data.status,
                segregateCartData: action.data.msg,
                profile_data:null
            }
            case CART_PROFILE_UPDATE : return {
                ...state,
                successLoading: false,
                profile_data :'Y'
            }
        case SEGREGATE_CART_FAILURE:
            return{ 
                ...state,
                successLoading: false,
                successError: action.error
            }
        default:
            return state;
    }
}
